import React, { useState } from 'react'
import I18n from 'lib/i18n'

export default function slideOne ({ slideIndex }) {
  const [expand, setExpand] = useState(false)

  return (
    <div className='slide.slide-1' style={{ display: slideIndex === 1 ? 'block' : 'none' }}>
      <div className='left-part'>
        <h3>{I18n.t('pages.how1.teachers_4_title')}</h3>
        <div className='only-responsive-inline-block' style={{ maxWidth: 410, margin: '0 auto', marginBottom: 10 }}>
          <img
            className='drop-shadow retina lazyload'
            data-src={`/assets/pages/how1/profile-${I18n.locale === 'fr' ? 'fr' : 'en'}.png`}
            data-retina={`/assets/pages/how1/profile-${I18n.locale == 'fr' ? 'fr' : 'en'}@2x.png`}
            style={{ maxWidth: '100%', width: 'auto !important', height: 'auto !important' }}
            alt=''
          />
        </div>
        <div dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.teachers_4') }} />
        <p className='learn-more-link' onClick={() => setExpand(true)} style={{ display: expand ? 'none' : 'block' }}>
          <a href='#'>{I18n.t('pages.how1.link_more')}</a>
        </p>
        <div className='learn-more-section' style={{ display: expand ? 'block' : 'none' }}>
          <div dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.teachers_4_more') }} />
        </div>
      </div>
      <div className='right-part not-responsive'>
        <div className='not-responsive-inline-block' style={{ maxWidth: 410, margin: '0 auto' }}>
          <img
            alt=''
            className='drop-shadow retina lazyload'
            style={{ maxWidth: '100%', width: 'auto !important', height: 'auto !important' }}
            data-src={`/assets/pages/how1/profile-${I18n.locale == 'fr' ? 'fr' : 'en'}.png`}
            data-retina={`/assets/pages/how1/profile-${I18n.locale == 'fr' ? 'fr' : 'en'}@2x.png`}
          />
        </div>
      </div>
    </div>
  )
}
